import { DateTime, IANAZone } from 'luxon';

export const accountZone = (value) => IANAZone.isValidZone(value) ? value : 'UTC';

// API timestamps without an offset are legacy UTC, never device-local time.
export function accountDate(value, zone) {
  const timezone = accountZone(zone);
  if (value instanceof Date) return DateTime.fromJSDate(value, { zone: timezone });
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return DateTime.fromISO(value, { zone: timezone });
  }
  return DateTime.fromISO(value || '', { zone: 'UTC' }).setZone(timezone);
}

export const dayKey = (value, zone) => accountDate(value, zone).toISODate();
export const formatAccountTime = (value, zone, pattern) => {
  const date = accountDate(value, zone);
  return date.isValid ? date.setLocale('en').toFormat(pattern) : '—';
};

export function localTimeChoices(date, time, zone) {
  const wallTime = `${date}T${time}`;
  const parsed = DateTime.fromISO(wallTime, { zone: accountZone(zone) });
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(wallTime) || !parsed.isValid || parsed.toFormat("yyyy-MM-dd'T'HH:mm") !== wallTime) return [];
  return parsed.getPossibleOffsets().sort((a, b) => a.toMillis() - b.toMillis());
}

export function eventTimes({ date, time, duration, allDay, offset }, zone) {
  if (allDay) {
    const start = accountDate(date, zone);
    if (!start.isValid || start.toISODate() !== date) throw new Error('Choose a valid date.');
    const end = start.plus({ days: 1 }).startOf('day');
    return { start_time: start.toUTC().toISO(), end_time: end.toUTC().toISO(), start_date: date, end_date: end.toISODate(), all_day: true };
  }
  const choices = localTimeChoices(date, time, zone);
  if (!choices.length) throw new Error('This local time does not exist. Choose another time.');
  const start = choices.length === 1 ? choices[0] : choices.find(value => String(value.offset) === offset);
  if (!start) throw new Error('This time occurs twice. Choose which UTC offset to use.');
  if (!Number.isFinite(duration) || duration < 15 || duration > 10080) throw new Error('Choose a duration between 15 minutes and 7 days.');
  return { start_time: start.toUTC().toISO(), end_time: start.plus({ minutes: duration }).toUTC().toISO(), all_day: false };
}
